<script>
import useSharedData from "@/use/SharedData.js";
import useSharedSelectData from "@/use/SharedSelectData.js";
import {computed, ref, watch} from "vue";

export default {
    name: "StrDataSelectTypeSelect",
    props: {
        value: Array,
        label: String,
        isDisabled: String,
        rules: Array,
        readonly: Boolean,
        openAll: Boolean,
    },
    setup(props, {emit}) {
        const {inputColor, backgroundColor} = useSharedData();
        const {dataSelectModules, dataSelectTypes} = useSharedSelectData();

        const modal = ref(false);
        const loading = ref(false);
        const dialog = ref(false);
        const selected = ref([]);
        const active = ref([]);
        const open = ref([0]);

        const list =computed(() => {
            let flatList = [];

            function traverseChildren(children) {
                children.forEach(child => {
                    flatList.push({ id: child.id, name: child.name });
                    if (child.children && child.children.length) {
                        traverseChildren(child.children);
                    }
                });
            }

            traverseChildren(dataSelectModules);
            return flatList;
        });


        function save() {
            emit("input", active.value[0]);
            emit("changed");
            dialog.value = false;
        }

        function clear() {
            active.value = [];
            emit("input", null);
        }

        watch(() => props.value, () => {
            active.value = [props.value];
        }, {immediate: true});

        return {
            list,
            modal,
            inputColor,
            backgroundColor,
            dataSelectModules,
            dataSelectTypes,
            loading,
            dialog,
            selected,
            active,
            open,
            save,
            clear
        }
    }
};
</script>

<template>
    <div>
        <v-dialog
            transition="dialog-bottom-transition"
            v-model="dialog"
            max-width="500"
            scrollable
        >
            <v-card>
                <v-card-text>
                    <v-treeview
                            :active.sync="active"
                            :open.sync="open"
                            activatable
                            :items="dataSelectModules"
                            :item-disabled="isDisabled"
                            color="teal"
                            selected-color="teal"
                            :selection-type="'independent'"
                            :open-all="openAll"
                            @input="save"
                            @update:active="save"
                    >
                        <template v-slot:prepend="{ open }">
                            <v-icon>
                                {{ open ? "mdi-folder-open" : "mdi-folder" }}
                            </v-icon>
                        </template>
                    </v-treeview>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-select
                v-model="active"
                :items="list"
                item-text="name"
                item-value="id"
                :label="label"
                prepend-inner-icon="mdi-circle-double"
                multiple
                :clearable="!readonly"
                :loading="loading"
                :menu-props="{ maxHeight: 0 }"
                outlined
                :color="inputColor"
                :background-color="backgroundColor"
                dense
                hide-details="auto"
                :rules="rules"
                @click="dialog = true"
        >
        </v-select>
        <input type="hidden"/>
    </div>
</template>